import React from "react";
import { GoogleMap, MarkerF, InfoWindowF } from "@react-google-maps/api";

export const CenterMap = ({
  center,
  onMapLoad,
  selectedMarker,
  onMarkerClick,
}) => {
  const mapContainerStyle = {
    width: "100%",
    height: "400px",
  };

  const centerLocation = {
    lat: center.latitude,
    lng: center.longitude,
  };

  return (
    <div className="mt-4">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={centerLocation}
        zoom={15}
        onLoad={onMapLoad}
      >
        <MarkerF
          position={centerLocation}
          onClick={() => onMarkerClick(center)}
        />
        {selectedMarker && (
          <InfoWindowF
            position={centerLocation}
            onCloseClick={() => onMarkerClick(null)}
          >
            <div>
              <h3 className="font-semibold">{center.centerName}</h3>
              <p>{center.formattedAddress}</p>
              {center.phone && <p>Phone: {center.phone}</p>}
              {center.website && (
                <a
                  href={center.website}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-charcoal hover:underline"
                >
                  Visit Website
                </a>
              )}
            </div>
          </InfoWindowF>
        )}
      </GoogleMap>
    </div>
  );
};
